import styled from "styled-components";

export const Container = styled.div`
  width: 100%;
  max-width: 100vw;
  height: 100%;
  overflow-x: hidden;
  overflow-y: auto;
  background-color: var(--color-blue);
  display: flex;
  flex-direction: column;

  footer {
    padding: 8px;
    text-align: center;

    small {
      color: #fff;
      text-transform: uppercase;
    }
  }
`;

export const Wrapper = styled.div`
  flex: 1;
  width: 100%;
  padding: 0;

  @media screen and (min-width: 768px) {
    //
  }

  @media screen and (min-width: 1024px) {
    //
  }
`;
